// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3XCob","filesListContainer":"PosDisputesFiles_filesListContainer__2FTdP","filesButton":"PosDisputesFiles_filesButton__5Vd_V"};